import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-398f04c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-info nongfu-button-wrap" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "device-info-wrap van-hairline--bottom" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "device-info-title" }, "设备信息", -1))
const _hoisted_5 = { class: "info-list" }
const _hoisted_6 = { class: "project-wrap van-hairline--bottom pb16" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "project-title" }, "保险方案", -1))
const _hoisted_8 = { class: "value tag-item wider-tag-wrap" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "project-select-tips"
}
const _hoisted_11 = { class: "project-wrap mt16" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "project-title" }, "生效日期及保障额度", -1))
const _hoisted_13 = { class: "effect-time-wrap" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "price" }
const _hoisted_16 = { class: "info" }
const _hoisted_17 = { class: "active-info" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "保障额度", -1))
const _hoisted_19 = { class: "value cycle-price-val" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "保险期限", -1))
const _hoisted_21 = {
  key: 0,
  class: "value"
}
const _hoisted_22 = {
  key: 1,
  class: "value"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "保障范围", -1))
const _hoisted_24 = {
  key: 0,
  class: "real-insurance-price"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "实付保费", -1))
const _hoisted_26 = { class: "value" }

import { v4 as uuidv4 } from 'uuid'
import { useRouter } from 'vue-router'
import { getActivedDayValue } from '../common'
import { getDeviceInsuranceInfo } from '@/apis/insurance'
import { getMaterialconfig } from '../jijia/material-config'
import {
  JijiaInsuranceStageMap,
  JijiaInsuranceProTypeMap,
  judgeInsuranceItemUseUbi,
  judgeInsuranceHasMaterialCheck,
  getInsuranceNameInfo,
  getInusranceEffectStr,
  getInsuranceCoverage,
} from '@/defination/insurance'
import {
  withDefaults,
  ref,
  Ref,
  ComputedRef,
  computed,
  onMounted,
  watch,
} from 'vue'
import {
  JijiaDeviceCardInfoListItem,
  DeviceJijiaInsuranceInfo,
  DeviceJijiaInsuranceInfoProjectItem,
} from '@/types/insurance'
import { toThousands } from '@/utils/tools'
import DeviceCardInfo from './device-card-info.vue'
import InsurancePriceDetail from './insurance-price-detail.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'insurance-form-detail-info',
  props: {
    sn: { default: '' },
    isReplenishment: { type: Boolean }
  },
  emits: [
  'next',
  'startTest',
  'loadSuccess',
  'currentChange',
  'currentJijiaChange',
],
  setup(__props: any, { emit: emits }) {

const props = __props as { sn: string, isReplenishment?: boolean };


const $router = useRouter()
const loading = ref(false)

const detailInfo: Ref<DeviceJijiaInsuranceInfo | null> = ref(null)
const detailListInfo: Ref<DeviceJijiaInsuranceInfo[] | null> = ref(null)
const effect_time = ref('')
const effectedDayValue = ref(0) // 激活多少天
const deviceInfo: Ref<JijiaDeviceCardInfoListItem | null> = ref(null)
const activeValue = ref(2)
const useEquityValue = ref('')
const currentInsuranceKey = ref('')

const jijiaInsuranceItem: ComputedRef<DeviceJijiaInsuranceInfoProjectItem | null> = computed(() => {
  return (
    currentCycleYearItem.value?.product_list.filter(
      (item) => item.pro_type === activeValue.value
    )[0] || null
  )
})
// 设备信息
// const deviceInfo: ComputedRef<JijiaDeviceCardInfoListItem | null>  = computed(()=> {})
const currentCycleYearItem = computed(() => {
  if (!currentInsuranceKey.value) {
    return null
  }
  return detailListInfo.value.filter((item) => item.uuid === currentInsuranceKey.value)[0]
})
// 是否显示UBI系数
const isShowUbiInfo = computed(() => judgeInsuranceItemUseUbi(currentCycleYearItem.value))
// 当前保险额度
const currentCycleYearItemCyclePrice = computed(() => {
  if (!currentCycleYearItem.value) {
    return 0
  }
  return getCurrentCycleYearPrice(currentCycleYearItem.value)
})
// 当前保险期限
const insuranceLimitTime = computed(() => {
  const detail = detailInfo.value
  if (!detail || !detail?.end_time) {
    return ''
  }
  return detail.end_time.split(' ')[0]
})
// 保险方案版本
const currentInsuranceList = computed(() => {
  if (!detailListInfo.value) {
    return []
  }
  let current = currentCycleYearItem.value || detailListInfo.value[0]
  return current.product_list.sort((item1, item2) => {
    // 进阶版 2 基础版1
    // 默认进阶版排前
    return item2.pro_type - item1.pro_type
  })
})
const currentInsurancePrice = computed(() => {
  if (!jijiaInsuranceItem.value) {
    return 0
  }
  return toThousands(Number(jijiaInsuranceItem.value.premium))
})

// 是否为进阶版
const isAdvanceInsurance = computed(() => activeValue.value === 2)
// 获取当前方案对应数据
function getCurrentCycleYearData(data: DeviceJijiaInsuranceInfo) {
  return data.product_list.filter((item) => item.pro_type === activeValue.value)[0]
}
// 获取方案当前价格
function getCurrentCycleYearPrice(data: DeviceJijiaInsuranceInfo) {
  let sourceValue = getCurrentCycleYearData(data).amount

  return toThousands(Number(sourceValue))
}
// 获取方案当前激活时间
function getCurrentCycleYearEqActivateDay(data: DeviceJijiaInsuranceInfo) {
  return getActivedDayValue(data.equipment.eq_activate_time, new Date(data.effect_time).getTime())
}
// 是否可使用权益
const canUseEquity = computed(
  () => !!currentCycleYearItem.value?.is_exist_equity && isAdvanceInsurance.value
)
// 确认使用权益
const confirmUseEquity = computed(() => canUseEquity.value && useEquityValue.value === '1')
const hasMaterialCheck = computed(() => {
  return judgeInsuranceHasMaterialCheck(jijiaInsuranceItem.value)
})
const needTest = computed(() => {
  // 本地测试临时注释
  // return currentCycleYearItem.value?.is_test
  return false
})
const insuraceCoverage = computed(() => {
  return getInsuranceCoverage(jijiaInsuranceItem.value)
})

watch(
  () => currentCycleYearItem.value,
  () => {
    emits('currentChange', currentCycleYearItem.value)
  }
)
watch(
  () => jijiaInsuranceItem.value,
  () => {
    emits('currentJijiaChange', jijiaInsuranceItem.value)
  }
)

function checkMaterialHandle() {
  if (!hasMaterialCheck.value) {
    return
  }
  $router.push({
    name: 'insurance-jijia-check-material',
    query: {
      uav: jijiaInsuranceItem.value.eq_model.toLocaleLowerCase(),
      type: String(jijiaInsuranceItem.value?.pro_type),
    },
  })
}

function detailListInfoItemClick(item: DeviceJijiaInsuranceInfo) {
  currentInsuranceKey.value = item.uuid
}
function projectChange(item: DeviceJijiaInsuranceInfoProjectItem) {
  activeValue.value = item.pro_type
}
// 格式化保险产品，进阶版-优质客户与非优质客户数据整合
function formatInsuranceProduct(data: DeviceJijiaInsuranceInfo) {
  const list = data.product_list
  const highQualityItem = list.find((item) => item.pro_type === 2 && item.is_high_quality === 2)
  const avanceItem = list.find((item) => item.pro_type === 2 && item.is_high_quality === 1)
  if (avanceItem) {
    avanceItem.highQualityInfo = highQualityItem
  }
  const newList = list.filter(
    (item) => item.pro_type === 1 || (item.pro_type === 2 && item.is_high_quality !== 2)
  )

  return newList
}
async function initDeviceInsuranceInfo() {
  loading.value = true
  try {
    // 保险类型：0、不支持投保 1、首保 2、首年二保
    let datas = await getDeviceInsuranceInfo(props.sn)
    let data = datas[0]
    detailListInfo.value = datas.map((item) => ({
      ...item,
      uuid: uuidv4(),
      product_list: formatInsuranceProduct(item),
    }))
    // 存在进阶版时默认设为2
    activeValue.value = datas[0].product_list.some((item) => item.pro_type === 2) ? 2 : 1
    currentInsuranceKey.value = detailListInfo.value[0].uuid
    detailInfo.value = data
    const equipment = data.equipment
    deviceInfo.value = {
      sn: equipment.eq_sn,
      headInfo: {
        name: equipment.eq_name || equipment.eq_model_name,
        img: equipment.eq_logo,
        sn: equipment.eq_sn,
        model: equipment.eq_model_name,
        activeTime: equipment.eq_activate_at,
      },
      //detailInfos: [getActiveTimeInfo(equipment.eq_activate_time)],
    }
    effectedDayValue.value = getActivedDayValue(
      equipment.eq_activate_time,
      new Date(data.effect_time).getTime()
    )
    effect_time.value = data.effect_time
    // needRefund.value = data.exist_policy ? '1' : ''
    // 重置是否使用优惠权益的选择
    useEquityValue.value = ''
    emits('loadSuccess')
  } catch (error) {
    console.log('error', error)
  }
  loading.value = false
}
// 加载数据后通知页面
onMounted(() => {
  if (props.sn) {
    initDeviceInsuranceInfo()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (deviceInfo.value)
            ? (_openBlock(), _createBlock(DeviceCardInfo, {
                key: 0,
                data: deviceInfo.value,
                imgSize: 64,
                class: "custom-card-info"
              }, null, 8, ["data"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentInsuranceList), (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(activeValue.value === item.pro_type ? 'tag-active' : ''),
                  key: item.pro_type,
                  onClick: ($event: any) => (projectChange(item))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_unref(getInsuranceNameInfo)(item).productType), 1)
                ], 10, _hoisted_9))
              }), 128))
            ]),
            (!__props.isReplenishment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, " * 如符合优质客户条件，投保进阶版可享受更多优惠！ "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailListInfo.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(currentInsuranceKey.value === item.uuid ? 'tag-active' : ''),
                  key: item.uuid,
                  onClick: ($event: any) => (detailListInfoItemClick(item))
                }, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(getInusranceEffectStr)(item.effect_time)) + " ", 1),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", null, _toDisplayString(item.effect_time?.split(' ')[0] || ''), 1),
                    _createElementVNode("div", _hoisted_17, " （设备激活 " + _toDisplayString(getCurrentCycleYearEqActivateDay(item)) + "天） ", 1)
                  ])
                ], 10, _hoisted_14))
              }), 128))
            ])
          ]),
          _createElementVNode("div", null, [
            _hoisted_18,
            _createElementVNode("div", _hoisted_19, "￥" + _toDisplayString(_unref(currentCycleYearItemCyclePrice)), 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_20,
            (__props.isReplenishment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(insuranceLimitTime)), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_22, "保险生效后 1年"))
          ]),
          _createElementVNode("div", { onClick: checkMaterialHandle }, [
            _hoisted_23,
            _createElementVNode("div", {
              class: _normalizeClass(["value", _unref(hasMaterialCheck) ? 'arrow-right' : ''])
            }, _toDisplayString(_unref(insuraceCoverage)), 3)
          ]),
          (!_unref(isShowUbiInfo))
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, "￥" + _toDisplayString(_unref(currentInsurancePrice)), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_unref(isShowUbiInfo))
      ? (_openBlock(), _createBlock(InsurancePriceDetail, {
          key: 0,
          data: _unref(jijiaInsuranceItem),
          cycleYear: _unref(currentCycleYearItem)?.cycle_year,
          isShowUbiInfo: _unref(isShowUbiInfo),
          canUseEquity: _unref(canUseEquity),
          useEquityValue: useEquityValue.value,
          confirmUseEquity: _unref(confirmUseEquity),
          currentInsurancePrice: _unref(currentInsurancePrice)
        }, null, 8, ["data", "cycleYear", "isShowUbiInfo", "canUseEquity", "useEquityValue", "confirmUseEquity", "currentInsurancePrice"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})